import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaViewer } from "./VaViewer-55652bd2.mjs";
const VaViewer = withConfigTransport(_VaViewer);
export {
  VaViewer as V
};
//# sourceMappingURL=index-c76589e8.mjs.map
